import React from 'react';
import PropTypes from 'prop-types';
import { wrapper } from '@redux/store';
import { appSetPageData } from '@redux/actions/app';
import getGraphQLServerClient from '@graphql/serverClient';
import wishesQuery from '@graphql/queries/wishesQuery';
import Wishes from '@components/pages/wishes/wishes';

console.log('[WISHES MODULE] Loading wuenschespeicher page module');

const WuenschespeicherPage = ({ ...data }) => {
  return <Wishes data={data} />;
};

export const getServerSideProps = wrapper.getServerSideProps(store => async ({ locale }) => {
  let props = null;
  const client = getGraphQLServerClient();

  let page;
  try {
    console.log('[WISHES] Making GraphQL request...');
    page = await client.request(wishesQuery, {
      sectionHandle: 'wuenschespeicher',
      site: `futurium${locale?.toUpperCase()}` || 'futuriumDE'
    });
    console.log('[WISHES] GraphQL request successful');
  } catch (error) {
    console.error('[WISHES] GraphQL request failed', error.message ?? error);
    throw error;
  }

  const languageSwitch = {
    lang: locale === 'de' ? 'en' : 'de',
    url: locale === 'de' ? '/en/database-of-hopes' : '/de/wuenschespeicher'
  };

  // transform navigation & footer data from graphql to expected data
  // TODO: adjust all pages to graphql and don't do that in the future..
  const {
    footer,
    footerGlobals,
    loginMask,
    navigation,
    globals,
    wishesApiKeys,
    wishes,
    categories,
    ...rest
  } = page;
  const pageData = {
    ...rest.page,
    wishes,
    categories,
    wishesApiKeys,
    globalTheme: globals.colorTheme,
    accessibility: {
      atFuturium: globals.a11yAtFuturium?.[0] ?? null,
      signLanguage: globals.a11ySignLanguage?.[0] ?? null,
      easyLanguage: globals.a11yyEasyLanguage?.[0] ?? null,
      digitalStatement: globals.a11yDigitalStatement?.[0] ?? null
    },
    lang: locale,
    languageSwitch,
    footer: {
      contentPages: footer.map(({ element, ...link }) => ({
        ...link,
        slug: element?.slug ?? null,
        type: element?.type ?? null
      })),
      ...footerGlobals
    },
    loginMask: {
      ...loginMask,
      input: {
        name: 'tokenId',
        placeholder: loginMask.placeholderText,
        required: true
      }
    },
    navigation: navigation.map(({ element, children, ...link }) => ({
      ...link,
      slug: element?.slug ?? null,
      type: element?.type ?? null,
      languageSwitch: 'de',
      children: children.map(({ element: subElement, ...subLink }) => ({
        ...subLink,
        slug: subElement?.slug ?? null,
        type: subElement?.type ?? null
      }))
    })),
    subNavigationHeadline: globals.subNavigationHeadline ?? null,
    subNavigationColumn1: globals.subNavigationColumn1 ?? null,
    subNavigationColumn2: globals.subNavigationColumn2 ?? null
  };

  props = {
    lang: locale,
    ...pageData
  };

  await store.dispatch(appSetPageData(props));

  return {
    props,
    notFound: !props.headline || !!props?.error
  };
});

WuenschespeicherPage.propTypes = {
  data: PropTypes.shape().isRequired
};

export default WuenschespeicherPage;
